export const defaultTableSettings = {
    theme: "grid",
    headStyles: {fillColor: "#73a4d3"},
    rowPageBreak: "avoid", 
};
export function openTabForPrinting(doc: any, fileName?: string) {
    var base64URL = doc.output('bloburi', {filename: fileName || "document.pdf"});
    var win = window.open();
    if (win) {
        win.document.write(`
            <html>
            <head>
                <title>${fileName}</title>
            </head>
            <body style="margin:0">
                <iframe src="` + base64URL  + `" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>
            </body>
            </html>
        `);
    }
}

export function printCenterAlignedText(doc: any, textString: string, currentY: number) {
    const textWidth = doc.getStringUnitWidth(textString) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(textString, textOffset, currentY);
}

export function printRightAlignedText(doc: any, textString: string, currentY: number) {
    const textWidth = doc.getStringUnitWidth(textString) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    var textOffset = doc.internal.pageSize.width - textWidth - 10;
    doc.text(textString, textOffset, currentY);
}